module.exports = __webpack_public_path__ + "img/vp-forward.ac726667.svg";